import React from 'react';
import ReactDOM from 'react-dom';
import App from './index.init.js';


ReactDOM.render(<App />, document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/index.js